module.exports = __webpack_public_path__ + "img/1221.aa65626e.png";